import store from "@/store/index";
import router from "@/router/index";
import { StoreModule } from "@/store/types";
import { GlobalActions } from "@/store/modules/global/types";
import { NotificationService } from "@/services/notification_service";
import { DuplicateCustomerMatch } from "@/models/netsuite/netsuite";

export class AuthError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static logout(): void {
    store.dispatch(StoreModule.Global + GlobalActions.AddLoggedIn, false);
    store.dispatch(StoreModule.Global + GlobalActions.AddRole, null);
    store.dispatch(StoreModule.Global + GlobalActions.AddAuthToken, null);
    NotificationService.show(
      "Your session has expired. Redirecting to login...",
      "danger"
    );
    setTimeout(() => {
      window.location.replace("/login");
    }, 2000);
  }
}

export class PermissionsError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}

export class LoginError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}
export class GenericError extends Error {
  static popup(message: string) {
    NotificationService.show(message, "danger");
  }
}

/**
 * FUPOF-191: create_customer refused to write a second record for a company
 * NetSuite already has. Carries the matching entities so the caller can show
 * them and let the rep either switch the quote to one or say to create anyway.
 */
export class DuplicateCustomerError extends Error {
  constructor(message: string, matches: DuplicateCustomerMatch[]) {
    super(message);
    this.matches = matches;
  }
  public matches: DuplicateCustomerMatch[];
  /**
   * Identifies this error through the layers of catch/rethrow between the
   * service and the review page. `instanceof` is not dependable for a subclass
   * of a builtin once the bundle has been transpiled, and a submit that reports
   * "something went wrong" instead of showing the duplicate is exactly the
   * failure this class exists to prevent.
   */
  public readonly isDuplicateCustomer = true;
}

export function isDuplicateCustomerError(
  err: unknown
): err is DuplicateCustomerError {
  return !!err && (err as any).isDuplicateCustomer === true;
}

export class APIError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}

export class NotFoundError extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}

export class BadRequest extends Error {
  constructor(message: string, statusCode: number) {
    super(message);
    this.statusCode = statusCode;
  }
  public statusCode: number;
  static popup(message: string, statusCode: number) {
    NotificationService.show(statusCode + " : " + message, "danger");
  }
}

export class ViewerError extends Error {
  static redirect(err?: string) {
    router.push("/error");
  }
}
